import React from "react";
import { Range } from "rc-slider";

const handleStyle = {
  width: "28px",
  height: "28px",
  backgroundColor: "#fff",
  border: `.5px solid #ef5753`,
  boxShadow: "0 3px 3px 0 rgba(0,0,0,.05), 0 2px 2px 0 rgba(0,0,0,.1)",
  marginLeft: "-14px",
  marginTop: "-15px",
  position: "absolute",
  borderRadius: "50%",
  touchAction: "pan-x",
  cursor: "pointer"
};

const railStyle = {
  backgroundColor: `#dae1e7`,
  height: "2px",
  position: "absolute",
  width: "100%"
};

const trackStyle = disabled => ({
  height: "2px",
  backgroundColor: `${disabled ? "#dae1e7" : "#ef5753"}`,
  position: "absolute"
});

export default class RangeSlider extends React.Component {
  render() {
    const {
      min,
      max,
      value,
      handleChange,
      handleOnAfterChange,
      disabled
    } = this.props;
    return (
      <div className="w-100 h-100">
        <Range
          className="relative pb-6 w-full"
          railStyle={railStyle}
          trackStyle={[trackStyle(disabled), trackStyle(disabled)]}
          handleStyle={[handleStyle, handleStyle]}
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          onAfterChange={handleOnAfterChange}
          allowCross={false}
          disabled={disabled}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Slider/Slider.js